import PropTypes from 'prop-types'

import style from '@aytm/app/stats/page/question-views/components/controls/styles/Controls.module.scss'
import mnStyle from '@aytm/app/stats/page/question-views/mn/components/controls/styles/Controls.module.scss'
import { NO_PRINT } from '@aytm/app/stats/page/question-views/components/lib/constants'
import { pressable } from '@aytm/app/stats/components/lib/pressable'

const Controls = ({ children, title, collapsed, onToggle }) => (
  <div className={`${style.component} ${NO_PRINT}`}>
    <span className={`p-field ${mnStyle.label}`}>{title}</span>
    {children}
    <span
      className={`${style.toggle} p-right`}
      // a menu test shows several sections, each with its own Expand/Collapse, so the name says which
      aria-label={title ? `${collapsed ? 'Expand' : 'Collapse'} ${title}` : undefined}
      aria-expanded={!collapsed}
      {...pressable(() => onToggle(!collapsed))}
    >
      {collapsed ? 'Expand' : 'Collapse'}
    </span>
  </div>
)

Controls.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  collapsed: PropTypes.bool,
  onToggle: PropTypes.func
}

Controls.displayName = 'Controls'

export default Controls
